import headings from 'virtual:relewise-facet-headings';

const FALLBACK_LOCALE = 'en';
const KEY_PREFIX = 'relewise.facets.';

export const getRelewiseFacetHeading = (locale: string, key: string): string =>
  headings[locale]?.[key] ||
  headings[FALLBACK_LOCALE]?.[key] ||
  `${KEY_PREFIX}${key}`;
